import OrderSummary from './orderSummary'
import { ProductVariantType } from './types'
export default class OrderCart {
  productVariants: ProductVariantType[]
  couponCode: string
  orderSummary: OrderSummary

  constructor(orderSummary: OrderSummary) {
    this.orderSummary = orderSummary
    this.productVariants = []
  }

  updateProductVariant(newProductVariant: ProductVariantType): void {
    let cartUpdated
    this.productVariants = this.productVariants.map((product) => {
      if (newProductVariant.id == product.id) {
        cartUpdated = true
        return newProductVariant
      }
      return product
    })
    if (!cartUpdated) {
      this.productVariants.push(newProductVariant)
    }
    this.cleanUp()

    this.orderSummary.renderSummary(this)
  }

  removeProductVariant(id: string): void {
    this.productVariants = this.productVariants.filter((variant) => id !== variant.id)
  }

  removeAllProductVariants(): void {
    this.productVariants = []
  }

  getProductVariant(input: HTMLInputElement, type = 'single'): ProductVariantType {
    let quantity: number
    const id = input.getAttribute('data-product-variant-id')
    const name = input.getAttribute('data-product-variant-name')
    const currency = input.getAttribute('data-product-variant-price-currency')
    const priceId = Number(input.getAttribute('data-product-variant-price-id'))
    const priceCents = Number(input.getAttribute('data-product-variant-price-cents'))
    if (input.type == 'checkbox') {
      quantity = Number(input.checked)
    } else if (type == 'single') {
      quantity = 1
    } else {
      quantity = Number(input.value)
    }
    return {
      id,
      name,
      quantity,
      currency,
      priceCents,
      priceId,
    }
  }

  incrementProductVariantQuantity(product: ProductVariantType, increment: number): void {
    this.productVariants = this.productVariants.map((p) =>
      p.id === product.id ? { ...p, quantity: p.quantity + increment } : p
    )
    this.cleanUp()
  }

  updateCouponCode(couponCode: string): void {
    this.couponCode = couponCode
  }

  totalCents(): number {
    return this.productVariants.reduce(function (acc, product) {
      return acc + product.quantity * product.priceCents
    }, 0)
  }

  clear(): void {
    this.productVariants = []
  }

  cleanUp(): void {
    this.productVariants = this.productVariants.filter((p) => p.quantity > 0)
  }
}
